// extracted by mini-css-extract-plugin
export var inner = "burger-menu-module--inner--a7b05";
export var logo = "burger-menu-module--logo--82404";
export var navBurger = "burger-menu-module--navBurger--08439";
export var open = "burger-menu-module--open--42f7d";
export var spacerText = "burger-menu-module--spacerText--3ec7f";
export var wrapper = "burger-menu-module--wrapper--72dc7";